module.exports = __webpack_public_path__ + "img/6.c93ea651.png";